import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { forgotPassword } from "../services/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const { id: uuid } = useParams();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    // Validasyonlar
    if (!email) {
      setError("Lütfen email adresinizi girin.");
      setLoading(false);
      return;
    }

    // Email format kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Lütfen geçerli bir email adresi girin.");
      setLoading(false);
      return;
    }

    try {
      const response = await forgotPassword(email);
      console.log("Şifre sıfırlama linki gönderildi:", response);
      setSuccess("Şifre sıfırlama linki email adresinize gönderildi!");
      
      // 3 saniye sonra login sayfasına yönlendir
      setTimeout(() => {
        navigate(`/${uuid}/login`);
      }, 3000);
    } catch (error) {
      console.error("Şifre sıfırlama linki gönderme hatası:", error);
      
      if (error.response?.data?.message) {
        setError(error.response.data.message);
      } else if (error.message) {
        setError("Şifre sıfırlama linki gönderilirken bir hata oluştu.");
      } else {
        setError("Email adresi bulunamadı veya bir hata oluştu.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate(`/${uuid}/login`);
  };

  return (
    <div className="h-screen max-h-screen overflow-hidden flex bg-white flex-col items-center justify-start">
      <div
        className="text-center h-[120px] w-full sm:max-w-[390px] flex items-center justify-center"
        style={{
          backgroundImage: "url(/assets/pngImages/welcomeScreen.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <img
          src="/assets/pngImages/jodiacLogo.png"
          alt="JODIAC Logo"
          className="h-[150px] mb-4 w-auto"
        />
      </div>
      
      <div className="w-full sm:max-w-[390px] -mt-6 z-20 rounded-t-3xl bg-white flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <div className="text-center mb-4 px-5 pt-4">
          <h2 className="text-2xl font-semibold text-black mb-1">
            Şifremi Unuttum
          </h2>
          <p className="text-black text-sm">
            Email adresinizi girin, size şifre sıfırlama linki gönderelim
          </p>
        </div>

        {/* Başarı Mesajı */}
        {success && (
          <div className="mb-4 px-5">
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-full text-sm">
              {success}
            </div>
          </div>
        )}

        {/* Hata Mesajı */}
        {error && (
          <div className="mb-4 px-5">
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-full text-sm">
              {error}
            </div>
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex-1 flex flex-col px-5">
          <div className="space-y-3">
            {/* Email */}
            <div>
              <input
                type="email"
                placeholder="Email Adresiniz"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-white px-4 py-2.5 rounded-full border-1 border-[#E9E9E9] shadow-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white/20"
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="space-y-3 mt-6">
            {/* Şifre Sıfırlama Linki Gönder Butonu */}
            <button
              type="submit"
              className="w-full bg-[#3DA7B5] text-white py-2.5 rounded-lg font-normal hover:bg-[#3DA7B5]/80 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? "Link Gönderiliyor..." : "Şifre Sıfırlama Linki Gönder"}
            </button>

            {/* Geri Dön Butonu */}
            <button
              type="button"
              onClick={handleBackToLogin}
              className="w-full bg-white text-[#6C6C6E] py-2.5 rounded-lg font-normal transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed border border-[#E9E9E9]"
              disabled={loading}
            >
              Giriş Sayfasına Dön
            </button>
          </div>
        </form>

        {/* Footer */}
        <div className="flex flex-col justify-center items-center px-5 pb-4">
          <div className="w-[179px] border-b border-[#E2E2E2] text-white text-sm">
            &nbsp;
          </div>
          <a
            href="https://store.jodi.ac"
            target="_blank"
            className="w-full mt-4"
          >
            <img
              src="/assets/pngImages/loginBanner.png"
              alt="JODIAC Logo"
              className="w-full h-auto min-h-[128px] max-h-[198px] object-contain"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
